import Base from './base';
import { tns } from "tiny-slider/src/tiny-slider";

class HomeSlider extends Base {
	constructor (el) {
		super(el);

		this.init();


	}

	init() {

		this.slider = tns({
			container: this.el,
			items: 1,
			autoplay: false,
			autoplayButtonOutput: false,
			controls: false,
			loop: true,
			rewind: true,
			nav: true,
			mouseDrag: true,
			navContainer: '.intro-carousel__dots',
			speed: 500,
		});

	
	}
}

export default HomeSlider;
